import React, { forwardRef, useImperativeHandle } from 'react';
import { Input, Form, Modal } from 'antd';
import PropTypes from 'prop-types';
import styles from '../Administration.module.css';

const DevicePopup = forwardRef(
  ({ form, visible, onCancel, onCreate, actionType, activeRecord }, ref) => {
    const { getFieldDecorator } = form;

    useImperativeHandle(
      ref,
      () => ({
        form,
      }),
      []
    );

    return (
      <Modal
        visible={visible}
        title={actionType ? `Update Device` : 'Add New Device'}
        width="470px"
        okText={actionType ? 'Update' : 'Add'}
        onCancel={onCancel}
        cancelText="Cancel"
        centered
        destroyOnClose
        onOk={onCreate}
        className={styles.newUserPopup}
        okButtonProps={{
          className: styles.addButton,
        }}
        cancelButtonProps={{
          className: styles.cancelButton,
        }}
      >
        <Form layout="vertical">
          <Form.Item label="Device Name">
            {getFieldDecorator('clientName', {
              rules: [
                { required: true, message: 'Please enter the device name!' },
              ],
              initialValue: actionType
                ? activeRecord && activeRecord.clientName
                : '',
            })(
              <Input
                placeholder="Enter device name"
                className={styles.newUserPopupInput}
              />
            )}
          </Form.Item>
          <Form.Item label="IP Address">
            {getFieldDecorator('clientIpAddress', {
              rules: [
                {
                  required: true,
                  message: 'Please enter the device IP address!',
                },
              ],
              initialValue: actionType
                ? activeRecord && activeRecord.clientIpAddress
                : '',
            })(
              <Input
                placeholder="Enter device IP address"
                className={styles.newUserPopupInput}
              />
            )}
          </Form.Item>
          <Form.Item label="MAC Address">
            {getFieldDecorator('clientMacAddress', {
              rules: [
                { required: true, message: 'Please enter the MAC address!' },
              ],
              initialValue: actionType
                ? activeRecord && activeRecord.clientMacAddress
                : '',
            })(
              <Input
                placeholder="Enter device MAC address"
                className={styles.newUserPopupInput}
              />
            )}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
);

DevicePopup.defaultProps = {
  form: {},
  visible: false,
  onCancel: (f) => f,
  onCreate: (f) => f,
  actionType: '',
  activeRecord: {},
};

DevicePopup.propTypes = {
  form: PropTypes.instanceOf(Object),
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
  actionType: PropTypes.string,
  activeRecord: PropTypes.instanceOf(Object),
};

export default Form.create()(DevicePopup);
